import { useEffect, useState } from 'react';

/**
 * Hook to use in Remix apps to then pass onto DOM components to show if the
 * app has been hydrated or not - useful for waiting in e2e tests.
 */
export const useIsHydrated = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return isHydrated;
};
